export const activate = (el) => {
  el.dataset.is_active = 'true';
};

export const deactivate = (el) => {
  el.dataset.is_active = 'false';
};
